import { makeStyles } from "@material-ui/core";

export default makeStyles({
    root: {
        backgroundColor: "transparent",
        whiteSpace: "pre-line",
    },
    flex: {
        // display: 'flex',
        // flex: 1,
        textAlign: "center"
    },
    flexReverse: {
        // display: 'flex',
        // flex: 1,
        justifyContent: "right"
    },
    media: {
        width: '70%',
        height: 0,
        paddingTop: "39.375%",
    },
    header: {
        alignItems: "start",
        backgroundColor: "transparent",
        paddingLeft: 30,
        paddingRight: 30,
    },
    reverse: {
        textAlign: "right",
    }
});
